module.exports = __webpack_public_path__ + "img/ic-minus-slate60.f81eb18c.svg";